// import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
    SET_ROW_DATA: 'SET_ROW_DATA',
    UPDATE_ROW_DATA: 'UPDATE_ROW_DATA',
    SET_TARGET_TYPE: 'SET_TARGET_TYPE',
    SET_JOB_ID: 'SET_JOB_ID',
    SET_TARGET: 'SET_TARGET',
    SET_EDIT_VAT_MODE: 'SET_EDIT_VAT_MODE',
    SET_EDIT_VAT_ONLY_MODE: 'SET_EDIT_VAT_ONLY_MODE',
}
